import { useState } from 'react';
import axios from '../../config/axiosConfig';

function GetListPage(): JSX.Element {
  const [key, setKey] = useState('');
  const [results, setResults] = useState<Record<string, string> | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleGetList = async () => {
    setLoading(true);
    setError(null);
    setResults(null);
    try {
      const response = await axios.post<Record<string, string>>(
        'api/AcctServices/GetAllLoginIDs',
        { Password: key }
      );
      setResults(response.data);
    } catch {
      setError('Failed to retrieve list.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={{ padding: '2rem' }}>
      <div style={{ marginBottom: '0.75rem' }}>
        <label htmlFor="get-list-key" style={{ marginRight: '0.5rem' }}>Enter key:</label>
        <input
          id="get-list-key"
          type="text"
          value={key}
          onChange={e => setKey(e.target.value)}
        />
      </div>
      <button onClick={handleGetList} disabled={loading || key.trim() === ''}>
        {loading ? 'Loading...' : 'Get List'}
      </button>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {results && (
        <table style={{ marginTop: '1rem', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ccc', padding: '0.4rem 0.8rem' }}>ID</th>
              <th style={{ border: '1px solid #ccc', padding: '0.4rem 0.8rem' }}>Email</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(results).map(([id, email]) => (
              <tr key={id}>
                <td style={{ border: '1px solid #ccc', padding: '0.4rem 0.8rem' }}>{id}</td>
                <td style={{ border: '1px solid #ccc', padding: '0.4rem 0.8rem' }}>{email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </main>
  );
}

export default GetListPage;
